import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=f6dfd194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6dfd194"]])

export default __exports__